import React, { useState, useEffect } from "react";
import SubHeader from "../components/Subheader/Subheader";
import axios from "axios";
import { Grid, CircularProgress, Typography } from "@mui/material";
import image1 from "../assets/image_1.png"; 
import image5 from "../assets/homeownersample.jpg"; 

const Homeowner = () => {
  const [homeowners, setHomeowners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const HomeownerOptions = [
    { value: "New to Old", label: "New to Old" },
    { value: "Old to New", label: "Old to New" },
  ];

  useEffect(() => {
    const fetchHomeowners = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await axios.get("https://usermanagementsystem-497524552274.us-central1.run.app/admin/get-users-by-role/HOMEOWNER", {
          headers: { Authorization: `Bearer ${token}` },
        });

        const formattedHomeowners = response.data.usersList.map((user) => ({
          Username: user.name || "Unknown",
          Lastname: user.username.split("@")[0],
          email: user.email,
          Mobilenumber: user.phone || "Not provided",
          Address: user.address || "No address provided",
          City: user.city || "Unknown",
          RegistrationDate: user.registrationDate || "Not available",
          UserType: user.userType || "Regular",
          Status: "Active",
          icon: image1,
          Insidepic: image5,
        }));

        setHomeowners(formattedHomeowners);
      } catch (err) {
        setError("Failed to fetch homeowners. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchHomeowners();
  }, []);

  return (
    <Grid container direction="column" alignItems="center" sx={{ padding: "20px" }}>
      <SubHeader name="Home Owners" options={HomeownerOptions} />

      {/* Added Homeowner List Heading */}
      <Typography variant="h5" sx={{ marginTop: "20px", fontWeight: "bold" }}>
        Homeowner List
      </Typography>

      {loading ? (
        <CircularProgress sx={{ marginTop: "20px" }} />
      ) : error ? (
        <Typography color="error" sx={{ marginTop: "20px" }}>{error}</Typography>
      ) : (
        <Grid container direction="column" alignItems="center" sx={{ width: "70%" }}>
          {homeowners.length > 0 ? (
            homeowners.map((homeowner, index) => (
              <Grid container key={index} sx={styles.card}>
                <Grid item>
                  <img src={homeowner.icon} alt="User" style={styles.image} />
                </Grid>
                <Grid item sx={styles.details}>
                  <Typography variant="h6">{homeowner.Username} {homeowner.Lastname}</Typography>
                  <Typography><strong>Status:</strong> {homeowner.Status}</Typography>
                  <Typography><strong>Email:</strong> {homeowner.email}</Typography>
                  <Typography><strong>Mobile:</strong> {homeowner.Mobilenumber}</Typography>
                  <Typography><strong>Address:</strong> {homeowner.Address}</Typography>
                  <Typography><strong>City:</strong> {homeowner.City}</Typography>
                  <Typography><strong>Registration Date:</strong> {homeowner.RegistrationDate}</Typography>
                  <Typography><strong>User Type:</strong> {homeowner.UserType}</Typography>
                </Grid>
                <Grid item>
                  <img src={homeowner.Insidepic} alt="Inside Pic" style={styles.insideImage} />
                </Grid>
              </Grid>
            ))
          ) : (
            <Typography>No homeowners found</Typography>
          )}
        </Grid>
      )}
    </Grid>
  );
};

// Styles
const styles = {
  card: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    border: "1px solid #ddd",
    borderRadius: "10px",
    padding: "15px",
    marginTop: "15px",
    backgroundColor: "#f8f9fa",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
    width: "100%",
  },
  image: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    marginRight: "15px",
  },
  insideImage: {
    width: "100px",
    height: "60px",
    borderRadius: "5px",
  },
  details: {
    flexGrow: 1,
    textAlign: "left",
  },
};

export default Homeowner;
